
/* eslint-disable vue/no-mutating-props */
// `target` is an orchestrator-owned person; this card records the verbal SOA
// onto target.soa (logic.js newSoa()).
import { COPY, ADMIN_PRODUCTS } from './copy'
import { soaUnanswered, soaInScope, soaProductNames, soaRepReady, personName } from './logic'

export default {
    props: {
        target: { type: Object, required: true },
        isPrimary: { type: Boolean, default: false },
    },
    data () {
        return { COPY, products: ADMIN_PRODUCTS }
    },
    computed: {
        soa () { return this.target.soa },
        name () { return personName(this.target) },
        productNames () { return soaProductNames(this.soa) },
        timeLabel () {
            return this.soa.captured_at ? this.$moment(this.soa.captured_at).format('h:mm A') : ''
        },
    },
    methods: {
        setAnswer (key, val) {
            if (this.soa.captured) return
            const next = this.soa.product_answers[key] === val ? null : val
            this.$set(this.soa.product_answers, key, next)
        },
        capture () {
            const missing = soaUnanswered(this.soa)
            if (missing.length) {
                this.$set(this.soa, 'attempted', true)
                this.$alert({ message: COPY.s4.toastUnanswered(missing.length), variant: 'warning' })
                return
            }
            if (!soaInScope(this.soa).length) {
                this.$alert({ message: COPY.s4.toastNoScope, variant: 'warning' })
                return
            }
            if (!soaRepReady(this.soa)) {
                this.$alert({ message: COPY.s4.toastRepIncomplete, variant: 'warning' })
                return
            }
            this.$set(this.soa, 'attempted', false)
            this.$set(this.soa, 'captured', true)
            this.$set(this.soa, 'captured_at', new Date().toISOString())
        },
        undo () {
            this.$set(this.soa, 'captured', false)
            this.$set(this.soa, 'captured_at', null)
        },
        toggleAbsent (checked) {
            this.$set(this.soa, 'absent', checked)
            // "Nobody consented, the advisor captures it later" and "a
            // representative consented on the line" are alternatives, never both.
            if (checked) this.$set(this.soa, 'representative', false)
            this.$set(this.soa, 'captured', false)
            this.$set(this.soa, 'captured_at', null)
        },
        toggleRep (checked) {
            this.$set(this.soa, 'representative', checked)
            if (checked) {
                this.$set(this.soa, 'absent', false)
            } else {
                this.$set(this.soa, 'representative_name', '')
                this.$set(this.soa, 'representative_relationship', '')
            }
            // Who consented is part of what was captured — changing it voids it.
            this.$set(this.soa, 'captured', false)
            this.$set(this.soa, 'captured_at', null)
        },
        setRep (key, val) {
            this.$set(this.soa, key, val)
            if (this.soa.captured) {
                this.$set(this.soa, 'captured', false)
                this.$set(this.soa, 'captured_at', null)
            }
        },
    },
}
